<template>
  <v-dialog
    v-model="dialogframeboton"
    persistent
    :fullscreen="componenteview != 0 ? true : false"
    :max-width="componenteview == 0 ? '1000px' : ''"
  >
    <v-card>
      <v-toolbar dark color="red-darken-4">
        <v-toolbar-title
          ><v-icon left>{{ iconodialogbtn }}</v-icon> {{ titledialogbtn }} -
          Solicitud: {{ itemprocesos.Numero_Solicitud }} -
          {{ itemprocesos.Primer_Apellido }}
          {{ itemprocesos.Primer_Nombre }}
        </v-toolbar-title>
        <v-toolbar-items>
          <v-btn
            v-if="componenteview == 0"
            class="d-none d-md-block"
            dark
            text
            @click="ConfirmarGuardado"
            >Guardar</v-btn
          >
          <v-btn
            class="d-none d-md-block"
            dark
            text
            @click="dialogframeboton = false"
            >Cerrar</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <!-- Cambio de Proceso ¡-->
        <v-form v-if="componenteview == 0" ref="form" autocomplete="off">
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <span
                  >Usuario asignado actualmente:
                  {{ itemprocesos.UsuarioAsigna }} -
                  {{ itemprocesos.DescUsuarioAsigna }}</span
                >
              </v-col>
              <!-- Usuarios -->
              <v-col cols="12">
                <v-autocomplete
                  v-model="userproceso"
                  :items="arrayuserpro"
                  :item-title="
                    (Dato) => Dato.Usuario_ID + ' - ' + Dato.DescUsuario_ID
                  "
                  item-value="Usuario_ID"
                  label="Usuario Nuevo:"
                  clearable
                ></v-autocomplete>
              </v-col>
              <!-- Procesos -->
              <v-col cols="12">
                <v-autocomplete
                  v-model="changeproceso"
                  :items="arrayprocesosasig"
                  :item-title="
                    (Dato) => Dato.Proceso + ' - ' + Dato.DescProceso
                  "
                  chips
                  closable-chips
                  item-value="Proceso"
                  label="Cambio de proceso:"
                  clearable
                  multiple
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <!-- Consulta Documentos ¡-->
        <card-consultadocumentos
          v-if="componenteview == 1"
          :infollaves="llaves"
        ></card-consultadocumentos>
        <!-- Consulta Dato ¡-->
        <card-dato
          v-if="componenteview == 2"
          :NumeroSolicitud="itemprocesos.Numero_Solicitud"
          :ProcesoActual="itemprocesos.Proceso_Actual"
        ></card-dato>
        <!-- Consulta  Estadistico ¡-->
        <card-consultaproceso
          v-if="componenteview == 3"
          :NumeroSolicitud="itemprocesos.Numero_Solicitud"
        ></card-consultaproceso>
        <!-- Trazabilidad ¡-->
        <card-traza
          v-if="componenteview == 4"
          :NumeroSolicitud="itemprocesos.Numero_Solicitud"
          :SistemaOrigen="'2'"
        ></card-traza>
      </v-card-text>
    </v-card>
  </v-dialog>
  <v-data-table
    :headers="headers"
    :items="desserts"
    :search="search"
    item-value="name"
    class="elevation-1"
    density="compact"
    height="500"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-dialog v-model="dialogframe" persistent max-width="1000px">
          <template v-slot:activator="{ props }">
            <v-btn
              color="cyan"
              icon="mdi-filter-menu"
              size="x-large"
              dark
              class="mb-2"
              v-bind="props"
              @click="CargueCombo"
            >
            </v-btn>
          </template>
          <v-card>
            <v-toolbar dark color="red-darken-4">
              <v-toolbar-title
                ><v-icon left>mdi-filter-menu</v-icon> Filtros
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn class="d-none d-md-block" dark text @click="reset"
                  >Limpiar</v-btn
                >
                <v-btn
                  class="d-none d-md-block"
                  dark
                  text
                  @click="ValidateCampos"
                  >Consultar</v-btn
                >
                <v-btn
                  class="d-none d-md-block"
                  dark
                  text
                  @click="dialogframe = false"
                  >Cerrar</v-btn
                >
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-form ref="form" autocomplete="off">
                <v-container fluid>
                  <v-row>
                    <!-- Filtro -->
                    <v-col cols="6">
                      <v-autocomplete
                        v-model="modelfiltro[0].filtro"
                        :items="items"
                        item-title="descripcion"
                        item-value="filtro"
                        label="Tipo de filtro:"
                        clearable
                      ></v-autocomplete>
                    </v-col>
                    <!-- Usuarios -->
                    <v-col cols="6">
                      <v-autocomplete
                        v-model="modelfiltro[0].contenido"
                        :items="arrayuser"
                        item-title="DescUsuarios"
                        item-value="Usuarios"
                        label="Usuarios:"
                        clearable
                      ></v-autocomplete>
                    </v-col>
                    <!-- Filtro -->
                    <v-col cols="6">
                      <v-autocomplete
                        v-model="modelfiltro[1].filtro"
                        :items="items"
                        item-title="descripcion"
                        item-value="filtro"
                        label="Tipo de filtro:"
                        clearable
                      ></v-autocomplete>
                    </v-col>
                    <!-- Proceso -->
                    <v-col cols="6">
                      <v-autocomplete
                        v-model="modelfiltro[1].contenido"
                        :items="arrayprocesos"
                        :item-title="
                          (Dato) => Dato.Proceso_ID + ' - ' + Dato.Descripcion
                        "
                        item-value="Proceso_ID"
                        label="Proceso:"
                        clearable
                      ></v-autocomplete>
                    </v-col>
                    <!-- Filtro -->
                    <v-col cols="6">
                      <v-autocomplete
                        v-model="modelfiltro[2].filtro"
                        :items="items"
                        item-title="descripcion"
                        item-value="filtro"
                        label="Tipo de filtro:"
                        clearable
                      ></v-autocomplete>
                    </v-col>
                    <!-- Solicitud -->
                    <v-col cols="6">
                      <v-text-field
                        v-model="modelfiltro[2].contenido"
                        label="Solicitud:"
                        prepend-inner-icon="mdi-folder-file"
                        clearable
                      ></v-text-field>
                    </v-col>
                    <!-- Filtro -->
                    <v-col cols="6">
                      <v-autocomplete
                        v-model="modelfiltro[3].filtro"
                        :items="items"
                        item-title="descripcion"
                        item-value="filtro"
                        label="Tipo de filtro:"
                        clearable
                      ></v-autocomplete>
                    </v-col>
                    <!-- Estado -->
                    <v-col cols="6">
                      <v-autocomplete
                        v-model="modelfiltro[3].contenido"
                        :items="arrayestado"
                        item-title="Descripcion"
                        item-value="Valor"
                        label="Estado:"
                        clearable
                      ></v-autocomplete>
                    </v-col>
                    <!-- Filtro -->
                    <v-col cols="6">
                      <v-autocomplete
                        v-model="modelfiltro[4].filtro"
                        :items="items"
                        item-title="descripcion"
                        item-value="filtro"
                        label="Tipo de filtro:"
                        clearable
                      ></v-autocomplete>
                    </v-col>
                    <!-- Fecha Inicio Solicitud -->
                    <v-col cols="6">
                      <v-text-field
                        v-model="modelfiltro[4].contenido"
                        label="Fecha Inicio Solicitud:"
                        prepend-inner-icon="mdi-calendar-cursor-outline"
                        type="date"
                        clearable
                      ></v-text-field>
                    </v-col>
                    <!-- Filtro -->
                    <v-col cols="6">
                      <v-autocomplete
                        v-model="modelfiltro[5].filtro"
                        :items="items"
                        item-title="descripcion"
                        item-value="filtro"
                        label="Tipo de filtro:"
                        clearable
                      ></v-autocomplete>
                    </v-col>
                    <!-- Fecha Fin Solicitud -->
                    <v-col cols="6">
                      <v-text-field
                        v-model="modelfiltro[5].contenido"
                        label="Fecha Fin Solicitud:"
                        prepend-inner-icon="mdi-calendar-cursor-outline"
                        type="date"
                        clearable
                      ></v-text-field>
                    </v-col>
                    <!-- Filtro -->
                    <v-col cols="6">
                      <v-autocomplete
                        v-model="modelfiltro[6].filtro"
                        :items="items"
                        item-title="descripcion"
                        item-value="filtro"
                        label="Tipo de filtro:"
                        clearable
                      ></v-autocomplete>
                    </v-col>
                    <!-- Identificación -->
                    <v-col cols="6">
                      <v-text-field
                        v-model="modelfiltro[6].contenido"
                        label="Número de identificación: "
                        prepend-inner-icon="mdi-account"
                        clearable
                      ></v-text-field>
                    </v-col>
                    <!-- Filtro -->
                    <v-col cols="6">
                      <v-autocomplete
                        v-model="modelfiltro[7].filtro"
                        :items="items"
                        item-title="descripcion"
                        item-value="filtro"
                        clearable
                        label="Tipo de filtro:"
                      ></v-autocomplete>
                    </v-col>
                    <!-- Dato -->
                    <v-col cols="6">
                      <v-autocomplete
                        v-model="modelfiltro[7].contenidocompleto"
                        label="Dato:"
                        :items="arraydatos"
                        :item-title="
                          (Dato) => Dato.Codigo + ' - ' + Dato.Descripcion
                        "
                        :item-value="
                          (Datovalue) =>
                            Datovalue.Codigo +
                            '&' +
                            Datovalue.Naturaleza +
                            '&' +
                            Datovalue.Tipo +
                            '&' +
                            Datovalue.Tabla_Valoracion
                        "
                        :click:clear="clearcontenido"
                        clearable
                      >
                        <template v-slot:item="{ props, item }">
                          <v-list-item
                            v-bind="props"
                            :title="
                              item?.raw?.Codigo + '-' + item?.raw?.Descripcion
                            "
                            @click="ChangeDato_ID()"
                          ></v-list-item>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      v-if="
                        modelfiltro[7].contenidocompleto != null &&
                        modelfiltro[7].contenidocompleto != ''
                      "
                      cols="6"
                    >
                      <v-autocomplete
                        v-model="modelfiltro[8].filtro"
                        :items="items"
                        item-title="descripcion"
                        item-value="filtro"
                        clearable
                        label="Tipo de filtro:"
                      ></v-autocomplete>
                    </v-col>
                    <!-- Seccion Campos datos -->
                    <!-- Combo -->
                    <v-col
                      v-if="
                        dato_id.Tipo == '2' &&
                        modelfiltro[7].contenidocompleto != null &&
                        modelfiltro[7].contenidocompleto != ''
                      "
                      cols="6"
                    >
                      <v-autocomplete
                        v-model="modelfiltro[8].contenido"
                        label="Tabla:"
                        clearable
                        :items="TablaNA"
                        :item-title="
                          (Dato) =>
                            Dato.Valor_Inferior + ' - ' + Dato.Descripcion
                        "
                        item-value="Valor_Inferior"
                      ></v-autocomplete>
                    </v-col>
                    <!-- Fecha -->
                    <v-col
                      v-else-if="
                        dato_id.Naturaleza == 'F' &&
                        modelfiltro[7].contenidocompleto != null &&
                        modelfiltro[7].contenidocompleto != ''
                      "
                      cols="6"
                    >
                      <v-text-field
                        clearable
                        type="date"
                        v-model="modelfiltro[8].contenido"
                        label="Fecha:"
                        prepend-icon="mdi-calendar"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      v-else-if="
                        (dato_id.Naturaleza == 'A' ||
                          dato_id.Naturaleza == 'N') &&
                        modelfiltro[7].contenidocompleto != null &&
                        modelfiltro[7].contenidocompleto != ''
                      "
                      cols="6"
                    >
                      <v-text-field
                        :label="'Digite contenido:'"
                        v-model="modelfiltro[8].contenido"
                        :maxlength="50"
                        :counter="50"
                        :hint="'Digite un registro existente'"
                        clearable
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-inner-icon="mdi-magnify"
          label="Buscar..."
          single-line
          variant="underlined"
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="text-center">
        <v-menu
          v-model="menubuttoms[item.raw.index]"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x
        >
          <template v-slot:activator="{ props }">
            <v-icon color="red-darken-4" v-bind="props">
              mdi-file-settings</v-icon
            >
          </template>
          <v-card flat>
            <v-card-text>
              <v-container>
                <v-row>
                  <!-- Reasignación Manual -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="IconosSolicitud(item.raw, 0)"
                        color="light-blue-accent-4"
                        v-bind="props"
                        >mdi-badge-account-horizontal-outline</v-icon
                      >
                    </template>
                    <span>Reasignación Manual</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Consulta de documento  -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="IconosSolicitud(item.raw, 1)"
                        color="#05AD58"
                        v-bind="props"
                        >mdi-cloud-download</v-icon
                      >
                    </template>
                    <span>Consulta de documentos</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Histórico de datos -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="IconosSolicitud(item.raw, 2)"
                        color="cyan"
                        v-bind="props"
                        >mdi-file-multiple-outline</v-icon
                      >
                    </template>
                    <span>Histórico de datos</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Histórico de procesos -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="IconosSolicitud(item.raw, 3)"
                        color="red"
                        v-bind="props"
                        >mdi-folder-search-outline</v-icon
                      >
                    </template>
                    <span>Histórico de procesos</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Trazabilidad -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="IconosSolicitud(item.raw, 4)"
                        color="cyan"
                        v-bind="props"
                        >mdi-chat-processing</v-icon
                      >
                    </template>
                    <span>Trazabilidad</span>
                  </v-tooltip>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-menu>
      </div>
    </template>
    <template v-slot:item.Identificacion="{ item }">
      <div>
        {{ item.raw.DescTipo + "-" + item.raw.Identificacion }}
      </div>
    </template>
    <template v-slot:item.Primer_Apellido="{ item }">
      <div>
        {{
          item.raw.Primer_Apellido +
          " " +
          item.raw.Segundo_Apellido +
          " " +
          item.raw.Primer_Nombre +
          " " +
          item.raw.Segundo_Nombre
        }}
      </div>
    </template>
    <template v-slot:item.Fecha_Inicio="{ item }">
      <div>
        {{ item.raw.Fecha_Inicio + " " + item.raw.Hora_Inicio }}
      </div>
    </template>
    <template v-slot:item.Fecha_Fin="{ item }">
      <div>
        {{ item.raw.Fecha_Fin + " " + item.raw.Hora_Fin }}
      </div>
    </template>
  </v-data-table>
  <div class="d-flex align-center flex-column">
    <!-- Linea de progreso -->
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import ConsultaDocumentos from "@/views/TCI/Documentos/ConsultaDocumentos/ConsultaDocumentos.vue";
import ConsultProceso from "@/views/TCI/ProcesosO/ConsultaEstadistico/ConsultaEstadistico.vue";
import HistoricoDatos from "@/views/TCI/ProcesosO/HistoricoDatos/HistoricoDatos.vue";
import Trazabilidad from "@/views/TCI/Personas/Trazabilidad/Trazabilidad.vue";
import store from "@/store";
export default {
  name: "cambio-proceso",
  components: {
    "card-consultadocumentos": ConsultaDocumentos,
    "card-consultaproceso": ConsultProceso,
    "card-dato": HistoricoDatos,
    "card-traza": Trazabilidad,
  },
  data() {
    return {
      search: "",
      progreso: false,
      dialogframe: false,
      dialogframeboton: false,
      iconodialogbtn: "",
      titledialogbtn: "",
      componenteview: 0,
      menubuttoms: [],
      userproceso: "",
      changeproceso: [],
      headers: [
        {
          title: "Acciones",
          align: "center",
          sortable: false,
          key: "actions",
        },
        {
          title: "Solicitud",
          align: "center",
          key: "Numero_Solicitud",
        },
        {
          title: "Identificación",
          align: "start",
          key: "Identificacion",
        },
        {
          title: "Nombre Cliente",
          align: "start",
          key: "Primer_Apellido",
        },
        {
          title: "Estado",
          align: "start",
          key: "DescEstado",
        },
        {
          title: "Evaluacion",
          align: "start",
          key: "DescEvaluacion",
        },
        {
          title: "Usuario Asignado",
          align: "start",
          key: "DescUsuarioAsigna",
        },
        {
          title: "Proceso Actual",
          align: "start",
          key: "DescProceso_Actual",
        },
        {
          title: "Usuario Creo",
          align: "start",
          key: "DescUsuario_Creo",
        },
        {
          title: "Fecha Inicial",
          align: "start",
          key: "Fecha_Inicio",
        },
        {
          title: "Usuario Actualizo",
          align: "start",
          key: "DescUsuarioActualizacion",
        },
        {
          title: "Fecha Actualizo",
          align: "start",
          key: "Fecha_Fin",
        },
      ],
      items: [
        {
          filtro: "=",
          descripcion: "Igual a",
        },
        {
          filtro: "LIKE",
          descripcion: "Similar a",
        },
        {
          filtro: ">=",
          descripcion: "Mayor igual a",
        },
        {
          filtro: "<=",
          descripcion: "Menor igual a",
        },
      ],
      modelfiltro: [
        {
          campo: "t10.A_Usuarios",
          filtro: "",
          contenido: "",
        },
        {
          campo: "S.NS_Proceso_Actual",
          filtro: "",
          contenido: null,
        },
        {
          campo: "S.NS_Numero_Solicitud",
          filtro: "",
          contenido: "",
        },
        {
          campo: "S.NS_Estado",
          filtro: "",
          contenido: "",
        },
        {
          campo: "S.NS_Fecha_Inicio",
          filtro: "",
          contenido: "",
        },
        {
          campo: "S.NS_FechaActualizacion",
          filtro: "",
          contenido: "",
        },
        {
          campo: "S.NS_Identificacion",
          filtro: "",
          contenido: "",
        },
        {
          campo: "SD_Dato",
          filtro: "",
          contenido: null,
          contenidocompleto: null,
        },
        {
          campo: null,
          filtro: null,
          contenido: null,
        },
      ],
      llaves: {
        Solicitud: null,
      },
      dato_id: {
        Codigo: "",
        Naturaleza: "",
        Tabla: "",
        Tipo: "",
      },
      itemprocesos: [],
      desserts: [],
      arrayestado: [],
      arrayprocesos: [],
      arrayuser: [],
      arraydatos: [],
      arrayuserpro: [],
      arrayprocesosasig: [],
      TablaNA: [],
      busquedacompleta: false,
    };
  },
  methods: {
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      this.busquedacompleta = false;
      for (var i = 0; i < this.modelfiltro.length; i++) {
        if (
          (this.modelfiltro[i].filtro == "" ||
            this.modelfiltro[i].filtro == null) &&
          this.modelfiltro[i].contenido != "" &&
          this.modelfiltro[i].contenido != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido == "" ||
            this.modelfiltro[i].contenido == null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido != "" ||
            this.modelfiltro[i].contenido != null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          this.busquedacompleta = true;
        }
      }
      // Consultas a Ejecutar
      if (!validate) {
        if (
          this.modelfiltro[7].contenido != null &&
          this.modelfiltro[7].contenido != ""
        ) {
          this.getConsultaSolicitudesDatos();
        } else {
          this.getConsultaSolicitudes();
        }
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos o no contiene el respecitivo filtro.",
        });
      }
    },
    // Consulta Solicitudes
    async getConsultaSolicitudes() {
      this.desserts = [];
      this.progreso = true;
      var data = {
        filtrado: this.modelfiltro,
        busquedacompleta: this.busquedacompleta,
      };
      this.axios
        .post("/consultasolicitudes/CT1/", data)
        .then((result) => {
          this.desserts = result.data;
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: " [404] No existen datos para esta consulta.",
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
          this.dialogframe = false;
        });
    },
    // Consulta Solicitudes Datos
    async getConsultaSolicitudesDatos() {
      this.desserts = [];
      this.progreso = true;
      var data = {
        filtrado: this.modelfiltro,
        busquedacompleta: this.busquedacompleta,
      };
      this.axios
        .post("/consultasolicitudes/CT0/", data)
        .then((result) => {
          this.desserts = result.data;
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: " [404] No existen datos para esta consulta.",
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
          this.dialogframe = false;
        });
    },
    // Consulta Usuarios Asignados
    async getUserAsignados() {
      this.arrayuser = [];
      this.progreso = true;
      this.axios
        .get("/procesoso/asignaciones/CD2/")
        .then((result) => {
          this.arrayuser = result.data;
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: " [404] No existen datos para esta consulta.",
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
          this.dialogframe = false;
        });
    },
    //Combo de devolver Usuarios
    async ConsultaUsuarioCombo() {
      if (
        this.itemprocesos.UsuarioAsigna != "" &&
        this.itemprocesos.UsuarioAsigna != null
      ) {
        this.progreso = true;
        this.axios
          .get(
            "/Seguridad/UsuariosProcesos/CD1/" + this.itemprocesos.PerfilAsigna
          )
          .then((result) => {
            this.arrayuserpro = result.data;
          })
          .catch((e) => console.log(e))
          .finally(() => {
            this.progreso = false;
          });
      }
    },
    // Consulta Procesos Asignados
    async ConsultaProcesosCombo() {
      this.progreso = true;
      this.axios
        .get(
          "/procesoso/asignaciones/CD5/" +
            this.itemprocesos.Numero_Solicitud +
            "/" +
            this.itemprocesos.UsuarioAsigna +
            "/" +
            this.itemprocesos.Proceso_Actual
        )
        .then((result) => {
          this.arrayprocesosasig = result.data;
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: " [404] No existen datos para esta consulta.",
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    //Combo para confirmar guardado
    async ConfirmarGuardado() {
      if (
        this.userproceso != null &&
        this.userproceso != "" &&
        this.changeproceso != null &&
        this.changeproceso.length > 0
      ) {
        if (this.itemprocesos.UsuarioAsigna != this.userproceso) {
          this.$swal({
            icon: "question",
            title: "Actualizar Usuario",
            html: "¿Está seguro que desea actualizar el usuario?<br>Esta acción no se puede deshacer luego de confirmada.",
            confirmButtonText: "Actualizar",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
            if (result.isConfirmed) {
              this.confirmProcesoAct();
            }
          });
        } else {
          this.$swal({
            icon: "warning",
            title: "Usuarios Iguales",
            html: "El usuario que desea cambiar es el mismo del actual.",
          });
        }
      } else {
        this.$swal({
          icon: "error",
          title: "¡Campos Obligatorios!",
          html: "Por favor ingrese la información en los campos respectivos.",
        });
      }
    },
    //Combo para cambiar proceso
    async confirmProcesoAct() {
      // Consulta los referencias de activos existentes.
      var userperfil = this.$store.getters.userperfil;

      try {
        this.progreso = true;
        var data = {
          Solicitud: this.itemprocesos.Numero_Solicitud,
          Usuarios: this.userproceso,
          Perfil: this.itemprocesos.PerfilAsigna,
          UsuarioLogin: userperfil.userInfo.Usuario_ID,
          Linea: this.itemprocesos.Linea_Actual,
          Proceso: this.changeproceso,
        };
        this.axios
          .put("/procesoso/asignaciones/UP1/", data)
          .then((response) => {
            this.$swal({
              icon: "info",
              title: "Exito",
              html: response.data,
            });
            this.dialogframeboton = false;
            this.ValidateCampos();
          })
          .catch((error) => {
            const registro = error.response.data;
            const mensajeerror =
              registro.Mensaje || registro.ExceptionMessage || registro;
            switch (error.response.status) {
              case 404:
                this.$swal({
                  icon: "warning",
                  title: "Consulta inexistente.",
                  html: " [404] No existen datos para esta consulta.",
                });
                break;
              default:
                this.$swal({
                  icon: "error",
                  title: "Error al consultar",
                  html:
                    " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                    mensajeerror +
                    "</code></small>",
                });
                break;
            }
          })
          .finally(() => {
            this.progreso = false;
          });
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Error al consultar datos",
          html:
            "Lo sentimos, ocurrió un error al intentar consultar los datos del proceso:<br><small><code>" +
            error.toString() +
            "</code></small>",
        });
      }
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.modelfiltro[7].contenido = null;
      this.busquedacompleta = false;
      this.$refs.form.reset();
    },
    ChangeDato_ID() {
      this.TablaNA = [];
      this.dato_id.Codigo = "";
      this.dato_id.Naturaleza = "";
      this.dato_id.Tipo = "";
      this.dato_id.Tabla = "";
      this.modelfiltro[8].campo = null;
      this.modelfiltro[8].filtro = null;
      this.modelfiltro[8].contenido = null;
      this.modelfiltro[7].contenido = null;
      if (
        this.modelfiltro[7].contenidocompleto != null &&
        this.modelfiltro[7].contenidocompleto != ""
      ) {
        var Dato_IDArray = this.modelfiltro[7].contenidocompleto.split("&");
        this.dato_id.Codigo = Dato_IDArray[0];
        this.modelfiltro[7].contenido = this.dato_id.Codigo;
        this.dato_id.Naturaleza = Dato_IDArray[1];
        this.dato_id.Tipo = Dato_IDArray[2];
        this.dato_id.Tabla = Dato_IDArray[3];
        if (this.dato_id.Naturaleza == "A") {
          this.modelfiltro[8].campo = "T14.SD_Valor_Alfanumerico";
        } else if (this.dato_id.Naturaleza == "N") {
          this.modelfiltro[8].campo = "T14.SD_Valor_Numerico";
        } else {
          this.modelfiltro[8].campo = "T14.SD_Valor_Fecha";
        }
        if (this.dato_id.Tipo == "2" && this.dato_id.Naturaleza == "A") {
          var InfoContenidoA = store.getters.MTablaAlfaNumerico.filter(
            (item) => item.Codigo == this.dato_id.Tabla
          );
          this.TablaNA = InfoContenidoA[0].ValoresAlfanumericos;
        } else if (this.dato_id.Tipo == "2" && this.dato_id.Naturaleza == "N") {
          var InfoContenidoN = store.getters.MTablaNumerico.filter(
            (item) => item.Codigo == this.dato_id.Tabla
          );
          this.TablaNA = InfoContenidoN[0].ValoresNumericos;
        }
      }
    },
    CargueCombo() {
      var InfoContenido = store.getters.MProcesos.filter(
        (item) => item.Proceso_ID != 0
      );
      this.arrayprocesos = InfoContenido;
      this.arrayestado = store.getters.MTablaSeleccion[1].TablaSeleccion;
      this.arraydatos = store.getters.MDatos;
    },
    IconosSolicitud(infodata, iconoelegido) {
      this.dialogframeboton = true;
      this.componenteview = iconoelegido;
      this.itemprocesos = infodata;
      switch (iconoelegido) {
        case 0: // Reasignación Manual
          this.iconodialogbtn = "mdi-badge-account-horizontal-outline";
          this.titledialogbtn = "Reasignación Manual";
          this.arrayuserpro = [];
          this.arrayprocesosasig = [];
          this.changeproceso = null;
          this.userproceso = null;
          if (
            this.itemprocesos.Estado == "A" ||
            this.itemprocesos.Estado == "T"
          ) {
            this.ConsultaUsuarioCombo();
            this.ConsultaProcesosCombo();
          } else {
            this.$swal({
              icon: "warning",
              title: "Estado Finalizado",
              html:
                "El estado es <b>" +
                this.itemprocesos.Estado +
                "-" +
                this.itemprocesos.DescEstado +
                "</b>, <br/> lo cual atribuye a que no se puede asignar el proceso. <br/>Si es un error, comuniquese con el administrador ",
            });
          }
          break;
        case 1: // Consulta de documentos
          this.iconodialogbtn = "mdi-cloud-download";
          this.titledialogbtn = "Consulta de documentos";
          this.llaves.Solicitud = this.itemprocesos.Numero_Solicitud
          break;
        case 2: //Histórico de datos
          this.iconodialogbtn = "mdi-file-multiple-outline";
          this.titledialogbtn = "Histórico de datos";
          break;
        case 3: //Histórico de procesos
          this.iconodialogbtn = "mdi-folder-search-outline";
          this.titledialogbtn = "Histórico de procesos";
          break;
        case 4: //Trazabilidad
          this.iconodialogbtn = "mdi-chat-processing";
          this.titledialogbtn = "Trazabilidad";
          break;
      }
    },
    clearcontenido() {
      this.modelfiltro[8].campo = null;
      this.modelfiltro[8].filtro = null;
      this.modelfiltro[8].contenido = null;
      this.modelfiltro[7].contenido = null;
    },
  },
  mounted() {
    this.getUserAsignados();
  },
};
</script>
